{
  "email": "E-Mail-Adresse",
  "noEmailDelivery": "Diese Installation sendet keine E-Mails. Bitten Sie eine Administratorin oder einen Administrator, Ihr Passwort zurückzusetzen.",
  "requestLink": "Link zum Zurücksetzen senden",
  "sent": "Wenn ein Konto diese Adresse nutzt, haben wir einen Link dorthin gesendet.",
  "title": "Passwort zurücksetzen"
}
